import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Discord = () => {
  return (
    <>
      <div className="content-box liquidity other">
        <div className="header">
          <div className="title">BEAR Community</div>

          <div className="text">
            $BEAR is a community project with most of the supply in the hands of
            the community
          </div>
        </div>

        <div className="content">
          <div className="image-box">
            <div className="image">
              <img src="images/community.jpg" alt="" />
            </div>
          </div>
          <div className="stats">
            <motion.button
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="button"
              layout="position"
            >
              <Link
                className="link"
                to="https://discord.gg/atGTNuzqH6"
                target="_blank"
                rel="noopener noreferrer"
              >
                Join BEAR Discord
              </Link>
            </motion.button>
            {/* <div className="stat">
              <div className="label">Total Supply</div>
              <div className="value">589,000,000 $BEAR</div>
            </div> */}
            <div className="text">
              Meet the BEAR fam in the official discord!
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Discord;
